export default __webpack_public_path__ + "static/media/165.3986fab8.png";